/**
 * Base of every model the interface observes. A model owns its state in private fields, exposes it through
 * getters and calls `changed()` after a mutation; React reads it through `useObservable`.
 */
export class Observable {
	#listeners = new Set<() => void>();
	#version = 0;

	/**
	 * Increases with every change, so a subscriber can tell that something changed without comparing state
	 */
	get version() {
		return this.#version;
	}

	/** Whether anything still listens, such as a mounted view */
	get observed() {
		return this.#listeners.size > 0;
	}

	/**
	 * @returns The function that ends the subscription
	 */
	subscribe = (listener: () => void) => {
		this.#listeners.add(listener);
		return () => void this.#listeners.delete(listener);
	};

	protected changed() {
		this.#version++;
		for (const listener of [...this.#listeners]) listener();
	}
}
